import { cn } from '../../lib/utils';
import { SKELETON_SHIMMER } from '../../shared/styles/animations';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Use shimmer effect instead of pulse (default: false) */
  shimmer?: boolean;
}

function Skeleton({ className, shimmer = false, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'rounded-md',
        shimmer ? SKELETON_SHIMMER : 'animate-pulse bg-muted',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
